import { PaperQuestion, PaperQuestionReq } from 'packages/sdks-next/growp'

export type TestPaperModalParams = {
  EditTestPaper: { paperId: number }
}

export type TestPaperParams = { AdminTestPaperList: null }

export enum JudgeMode {
  // 自动判卷
  Auto = 'auto',
  // 人工判卷
  Manual = 'manual',
}

export type QuestionSetting = {
  judgeMode?: JudgeMode
}

export interface Question extends PaperQuestion {
  setting?: QuestionSetting
}

export interface QuestionReq extends PaperQuestionReq {
  setting?: QuestionSetting
}
